import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

console.log('[index.tsx] Module loaded at:', new Date().toISOString());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

console.log('[index.tsx] Rendering app...');

// Temporarily disable StrictMode to see if that's causing issues
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Debug HMR (Hot Module Replacement)
// @ts-ignore - webpack HMR types
if (module.hot) {
  console.log('[HMR] Hot module replacement is enabled');
  
  let reloadCount = 0;
  
  // @ts-ignore - webpack HMR types
  module.hot.accept('./App', () => {
    reloadCount++;
    console.log(`[HMR] App module reloaded! Count: ${reloadCount}`);
  });
  
  // @ts-ignore - webpack HMR types
  module.hot.addStatusHandler((status: string) => {
    console.log('[HMR] Status changed to:', status);
  });
}
